import { BlockStack, Text } from '@shopify/polaris';

export interface NotificationListProps {
  content: React.ReactNode | string;
}

export const GNotificationList = ({ data }: { data: NotificationListProps[] }) => (
  <BlockStack gap="400">
    {data?.map((item, index) => (
      <Text as="p" variant="bodyMd" key={index} children={item.content}></Text>
    ))}
  </BlockStack>
);
